<template>
	<div>
		<sBox title="Grade de gestores">
			<div slot="tools">
				<aBtn
					action="private-save-sellers"
					@click="$refs.modal.open()"
					text="Gestores"
					icon="plus"
					size="sm"
					type="success"
				/>
			</div>
			<div slot="body">
				<br />
				<div class="row">
					<div class="pull-right col-sm-4">
						<div class="input-group">
							<span class="input-group-addon">
								<i class="fa fa-search"></i>
							</span>
							<input
								type="text"
								@input="filter($event.target.value)"
								placeholder="Pesquisar"
								class="form-control"
							/>
						</div>
					</div>
				</div>
				<br />
				<sTable
					ref="tab"
					actionRead="private-read-sellers"
					actionDelete="private-delete-sellers"
					:labels="labels"
					:actions="actions"
					:functions="functions"
					debug
					@comissao="(data) => $refs.comissao.open(data)"
					@edit="(data) => $refs.modal.open(data)"
				/>
			</div>
		</sBox>
		<modal ref="modal" @update="$refs.tab.updateTable()" />
		<comissao ref="comissao" />
	</div>
</template>
<script>
	// import WBS from 'js/http'
	import sTable from 'table';
	import sBox from 'box';
	import aBtn from 'btn';
	import modal from './modal.vue';
	import comissao from './comissao.vue';

	import pad from 'js/pad';

	export default {
		name: 'AppCadastroCategorias',
		components: { sTable, sBox, aBtn, modal, comissao },
		data() {
			return {
				labels: [
					{ data: 'cod', label: 'Cod' },
					{ data: 'vendedor', label: 'Vendedor' },
					{ data: 'comissao', label: 'Comissão' },
				],
				actions: [
					'delete',
					'edit',
					{
						text: 'Comissão',
						color: 'btn-warning',
						icon: 'fa-handshake-o',
						emit: 'comissao',
					},
				],
				functions: [
					{
						cod: 'cod',
						fx: (val) => {
							return pad(val, 5);
						},
					},
					{
						cod: 'comissao',
						fx: (val) => {
							return val + '%';
						},
					},
				],
			};
		},
		methods: {
			filter(data) {
				if (data != '') {
					this.$refs.tab.setFilter(
						`cod = '${data}' or vendedor like '%${data}%' `
					);
				} else this.$refs.tab.setFilter('');
				this.$refs.tab.updateTable();
			},
		},
		mounted() {
			this.$emit('setHeader', ['Vendedores', '']);
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/cadastros/sellers/index.vue